import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { actualizarModulo } from '../../store/slices/modulo';

type Props = {
  open: boolean
  setOpen: any
}

const EditarModulo = ({open, setOpen}: Props) => {

  const dispatch = useDispatch<AppDispatch>();

  const { curso } = useSelector((state: RootState) => state.curso);
  const { modulos, modulo } = useSelector((state: RootState) => state.modulo);

  const [nombre, setNombre] = useState(modulo?.nombre)
  const [error, setError] = useState('');

  useEffect(() => {
    if (error !== '') {
        const timer = setTimeout(() => {setError('');}, 3000);
        return () => clearTimeout(timer);
    }
  }, [error]);

  const handleEditarModulo = () => {

    if (nombre === '') {
      return setError('Ingresa el nombre del módulo')
    }

    if (curso.cid && modulos.length > -1 && nombre !== '') {
      const nuevoModulo = {
        mid: modulo.mid,
        cid: modulo.cid, 
        modulo: modulo.modulo, 
        nombre: nombre
      }
      dispatch(actualizarModulo(nuevoModulo));
      setOpen(false);
    }
  }

  return (
    <Dialog 
      open={open}
      fullWidth
    >
      <DialogTitle>
        Editar Módulo
      </DialogTitle>
      <DialogContent>
        {
          error &&
          <div className="alert alert-danger" style={{position: 'absolute', bottom: 5, left: 20, padding: 5 }}>
            {error}
          </div>
        }

        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Nombre del Módulo"
          type="email"
          fullWidth
          variant="standard"
          value={nombre}
          onChange={(e: any) => setNombre(e.target.value)}
          autoComplete="off"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancelar</Button>
        <Button onClick={() => handleEditarModulo()}>Actualizar</Button>
      </DialogActions>
    </Dialog>
  )

}

export default EditarModulo;